import { render, staticRenderFns } from "./cust_footer_component.vue?vue&type=template&id=70c85fd1&scoped=true&"
import script from "./cust_footer_component.vue?vue&type=script&lang=js&"
export * from "./cust_footer_component.vue?vue&type=script&lang=js&"
import style0 from "./cust_footer_component.vue?vue&type=style&index=0&id=70c85fd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c85fd1",
  null
  
)

export default component.exports